import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type SalesOffice = {
  Id: string
  Value: string
}

type SalesOfficeStore = {
  salesOffices: SalesOffice[]
  resetSalesOffices: () => void
  setSalesOffices: (salesOffices: SalesOffice[]) => void
}

export const useSalesOfficesStore = create<SalesOfficeStore>()(
  persist(
    (set) => ({
      salesOffices: [],
      resetSalesOffices: () => set({ salesOffices: [] }),
      setSalesOffices: (salesOffices: SalesOffice[]) =>
        set(() => ({ salesOffices })),
    }),
    {
      name: 'sales-offices-storage',
      storage: encryptedStorage(),
    }
  )
)
